import { ChangeEvent, useMemo, useState } from 'react';
import { InputProps } from 'antd';
import { debounce } from 'lodash';

export const useDebouncedInputValue = (defaultValue = '', wait = 600) => {
  const [value, setValue] = useState<string>(defaultValue);
  const [debouncedValue, setDebouncedValue] = useState<string>(defaultValue);

  const _setDebouncedValue = useMemo(() => debounce(setDebouncedValue, 600), []);

  const getInputProps = (props?: Omit<InputProps, 'value'>) => ({
    ...props,
    value,
    onChange: (event: ChangeEvent<HTMLInputElement>) => {
      setValue(event.currentTarget.value);
      _setDebouncedValue(event.currentTarget.value);

      props?.onChange && props.onChange(event);
    },
  });

  return {
    value: debouncedValue,
    getInputProps,
  };
};
